module.exports = __webpack_public_path__ + "8a1c9f11bd86602d4cd25f71c6dba68e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/_common/BeerCard/images/selling-fast.png
// module id = Y3iv
// module chunks = 0